import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiList = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiList'];
  defaultProps?: ComponentsProps['MuiList'];
  variants?: ComponentsVariants['MuiList'];
};

export const MuiList: MuiList = {
  styleOverrides: {
    root: {
      // forcing 8px padding due to MUI padding-right: 0 scrollbar issue
      padding: '8px !important',
    },
  },
};
